<template>
  <div>
    <apexchart
      v-if="sortedCategories.length"
      type="bar"
      :height="Math.max(300, sortedCategories.length * 44 + 80)"
      :options="opts"
      :series="series"
    />
    <empty-state
      v-else
      icon="mdi-tag-multiple-outline"
      :title="$t('no_data')"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";

const SHIFT_COLORS = ["#1E88E5", "#43A047", "#FB8C00", "#8E24AA"];

export default {
  name: "GroupMealsCategoriesChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    categoryAgg() {
      const map = {};
      for (const item of this.orders) {
        const cat = item.category_name || this.$t("other");
        if (!map[cat]) map[cat] = [0, 0, 0, 0];
        const s = (item.shift || 1) - 1;
        if (s >= 0 && s < 4) map[cat][s] += Number(item.quantity || 0);
      }
      return map;
    },
    sortedCategories() {
      return Object.entries(this.categoryAgg)
        .map(([name, shifts]) => ({
          name,
          total: shifts.reduce((a, b) => a + b, 0),
          shifts,
        }))
        .sort((a, b) => b.total - a.total);
    },
    categories() {
      return this.sortedCategories.map((c) => c.name);
    },
    series() {
      return this.shiftLabels.map((label, i) => ({
        name: label,
        data: this.sortedCategories.map((c) => c.shifts[i] || 0),
      }));
    },
    opts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          fontFamily: "Roboto, sans-serif",
        },
        plotOptions: { bar: { horizontal: true, borderRadius: 3, barHeight: "65%" } },
        colors: SHIFT_COLORS,
        xaxis: { categories: this.categories, labels: { style: { fontSize: "12px" } } },
        yaxis: { labels: { style: { fontSize: "12px" }, maxWidth: 220 } },
        legend: { position: "bottom", horizontalAlign: "center" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: "#f1f1f1" },
        responsive: [
          {
            breakpoint: 600,
            options: {
              yaxis: { labels: { style: { fontSize: "11px" }, maxWidth: 130 } },
              xaxis: { labels: { style: { fontSize: "11px" } } },
              legend: { fontSize: "12px", itemMargin: { horizontal: 6 } },
              plotOptions: { bar: { barHeight: "55%" } },
            },
          },
        ],
      };
    },
  },
};
</script>
